import { domToReact } from "html-react-parser"
import React from "react"

export const heroTitleOptions = {
  replace: element => {
    const { name, children } = element
    if (name === "h1") {
      return (
        <h1 className="mt-4 text-4xl tracking-tight font-bold text-charlestonGreen-500 sm:mt-5 sm:text-5xl lg:mt-6 xl:text-5xl">
          {domToReact(children, heroTitleOptions)}
        </h1>
      )
    }

    if (name === "strong") {
      return (
        <span className="text-blue-400">
          {domToReact(children, heroTitleOptions)}
        </span>
      )
    }
    return null
  },
}

export const heroBlueTitleOptions = {
  replace: element => {
    const { name, children } = element
    if (name === "h1") {
      return (
        <h1 className="mt-4 text-4xl tracking-tight font-bold text-blue-800 sm:mt-5 sm:text-5xl lg:mt-6 xl:text-5xl">
          {domToReact(children, heroBlueTitleOptions)}
        </h1>
      )
    }

    if (name === "strong") {
      return (
        <span className="text-blue-600">
          {domToReact(children, heroBlueTitleOptions)}
        </span>
      )
    }
    return null
  },
}

export const darkHeroTitleOptions = {
  replace: element => {
    const { name, children } = element
    if (name === "h1") {
      return (
        <h1 className="mt-1 text-4xl font-extrabold sm:text-5xl sm:tracking-tight lg:text-6xl text-white">
          {domToReact(children, darkHeroTitleOptions)}
        </h1>
      )
    }

    if (name === "strong") {
      return (
        <span className="text-cabaret-600">
          {domToReact(children, darkHeroTitleOptions)}
        </span>
      )
    }
    return domToReact(children, darkHeroTitleOptions)
  },
}
